import axios from 'axios'

const API_V1_URL = process.env.API_V1_URL

export default function(apiToUser) {
  return {
    updateUser(id, update) {
      return axios.patch(API_V1_URL + '/user/' + id, update)
    },
    // AUTH
    login(email, password, role) {
      var credentials = {email, password}
      return axios.post(API_V1_URL + '/session', credentials)
        .then(res => {
          if (res.data.role === role) {
            // Allow only users with the specified role to login
            return {
              user: apiToUser(res.data),
              csrfToken: res.csrfToken,
            }
          } else {
            // Do NOT allow other users to login
            let err = new Error('There is no such user')
            err.wrongAppErr = true
            return Promise.reject(err)
          }
        })
    },
    logout() {
      return axios.delete(API_V1_URL + '/session')
    },
    setNewPass(token, userId, password) {
      // The args are taken from the URL for password reset
      var postData = {token, userId, password}
      return axios.patch(API_V1_URL + '/credentials/reset', postData)
    },
    changePass(oldPassword, newPassword) {
      // The user changes the password themselves
      var postData = {oldPassword, newPassword}
      return axios.patch(API_V1_URL + '/credentials/change', postData)
    },
  }
}



// WEBPACK FOOTER //
// ./src/services/userService.js